import React, { useCallback, useContext } from 'react'
import { TabContext } from '@mui/lab'
import useFavurTranslation from 'hooks/useFavurTranslation'
import useStateBackLink from 'hooks/useStateBackLink'
import { useHistory } from 'react-router-dom'
import BackButton from 'redesign/components/atoms/Buttons/BackButton'
import TabsHeader from 'redesign/components/organisms/headers/tabs-header'
import Page from 'redesign/components/templates/Page'
import { EVENT_TAB_TO_TIMELINE } from 'redesign/pages/Events/constants'
import SubheaderTabContext from 'redesign/services/SubheaderTabs/context'
import type { OwnerIdPageProps } from 'redesign/shared/types'
import EventsListPanel from '../events-list-panel'

const EventsPageBody: React.FC<OwnerIdPageProps> = ({ match }) => {
  const { t } = useFavurTranslation()
  const { selectedTabName, pages } = useContext(SubheaderTabContext)
  const ownerId = parseInt(match.params.ownerId)
  const { pushBackLinkOrDefault } = useStateBackLink()
  const history = useHistory()

  const backButtonAction = useCallback(
    () => pushBackLinkOrDefault(() => history.goBack()),
    [history, pushBackLinkOrDefault],
  )

  return (
    <TabContext value={selectedTabName}>
      <Page
        header={
          <TabsHeader startContent={<BackButton onGoBack={backButtonAction} />} title={t('page.cms.event.header')} />
        }
        removeLastMargin
      >
        {pages?.map(({ name }) => (
          <EventsListPanel key={name} eventTimeline={EVENT_TAB_TO_TIMELINE[name]} name={name} ownerId={ownerId} />
        ))}
      </Page>
    </TabContext>
  )
}

export default EventsPageBody
